import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'The Inner Tug-of-War: Why You Feel So Torn (and What to Do About It)',
  slug: 'the-inner-tug-of-war-why-you-feel-so-torn-and-what-to-do-about-it',
  category: 'IFS',
  date: '2026-01-08',
  image: 'https://dpnelson.com/wp-content/uploads/2026/01/unnamed-2026-01-08T210332.898.jpg',
  excerpt: 'Have you ever caught yourself arguing with yourself?',
  body: `Have you ever caught yourself arguing with yourself?

Driving down Highway 1 last week, I caught myself arguing in my head about whether to cancel a meeting. Part of me wanted to push through and get the meeting done, and another part wanted to go home and make pizza.

Maybe you've had your own version of that debate: one part of you pushing ahead, another begging for rest. A tug-of-war like that can wear you down. It's like trying to drive with one foot on the gas and one on the brake.

## The Real Problem

Most of us pick a side, usually the one that sounds responsible, while ignoring the one that just wants a nap. I went for the pizza this time.

When these parts of ourselves don't trust each other (or our true selves), they pull us in opposite directions. That inner friction shows up as procrastination, indecision, burnout, or the quiet dread of never quite feeling right, no matter what we choose.

## A New Way to See It

In my work as an IFS coach, I remind people they don't have to pick a side at all. You can step into the role of Self—the calm, clear, compassionate presence that listens to each voice without taking sides. From that place, you can hear what every part actually needs, not just what it may be shouting.

A client once said, "It felt like calling a truce inside my own head, and there was finally peace!" And that's the point. When your parts trust that you're listening, they stop fighting for control and start working together.

### Try This

Here's something that's helped me when I'm pulled in two directions.

- What are the two (or more) parts of me pulling in different directions right now?
- Ask each part, "What are you afraid might happen if you don't get your way?"
- What might happen if I stopped fighting them and just listened?

You don't have to solve it immediately. Just starting that conversation can begin to restore inner alignment.

## Coming Home

When your inner team finally works together, it's like the static clears, and you can breathe again.

If this tug-of-war feels familiar, IFS coaching can help you rebuild that inner trust. Call me at 415-869-0411 to discuss how coaching can help you move forward with confidence.`,
}

export default post
